module.exports = __webpack_public_path__ + "static/media/io.0c878991.svg";